import React, {useEffect, useState} from 'react'
import {Modal, Button} from 'react-bootstrap'
import {addProduct, editProduct} from '../../../Api'
import {AlertDialog} from '../../../components/Dialog/Dialog'
import {Form, Formik} from 'formik'
import TextInput from '../../../components/Form/TextInput'
import * as Yup from 'yup'
import TextArea from '../../../components/Form/TextArea'
import Checkbox from '../../../components/Form/Checkbox'
import InputImage from './InputImage'
import {IProduct} from '..'

interface IModalProduct {
  show: boolean
  onHide: () => void
  onConfirm: (producto: any, isEdit: boolean) => void
  product: IProduct | {} | null
}

const ModalProduct = ({show, onHide, onConfirm, product}: IModalProduct) => {
  const [file, setFile] = useState<File | null>(null)
  const [message, setMessage] = useState('')
  const [title, setTitle] = useState('')
  const [success, setSuccess] = useState(false)
  const [loading, setLoading] = useState(false)
  const validationSchema = Yup.object().shape({
    titulo: Yup.string().required('El título es obligatorio').max(255, 'Máximo 255 caracteres'),
    descripcion: Yup.string().required('La descripción es obligatoria'),
    contacto: Yup.string().required('El contacto es obligatorio').max(255, 'Máximo 255 caracteres'),
    imagen: Yup.string().required('La imagen es obligatoria'),
  })

  useEffect(() => {
    if (show) {
      setFile(null)
      setMessage('')
    }
  }, [show])

  const isEdit = product && 'id' in product

  const handleAddOrEditProduct = async (values: any) => {
    try {
      setLoading(true)
      const {titulo, descripcion, contacto, vigente} = values
      const formData = new FormData()
      formData.append('titulo', titulo)
      formData.append('descripcion', descripcion)
      formData.append('contacto', contacto)
      formData.append('vigente', vigente ? '1' : '0')
      if (file) {
        formData.append('imagen', file)
      }
      const {status, data} = await (isEdit
        ? editProduct(product.id, formData)
        : addProduct(formData))
      setLoading(false)
      if (status === 201 || status === 200) {
        if (!Boolean(parseInt((data.producto as IProduct).autorizado))) {
          console.log(data.producto)
          setSuccess(true)
          setTitle('Muchas gracias por publicar!!')
          setMessage('Su aviso será visible una vez que sea visado por Relaciones Médicas.')
        }
        onConfirm(data.producto, isEdit || false)
      }
    } catch (error: any) {
      setLoading(false)
      setSuccess(false)
      setTitle('Errores')
      const errors = error.response?.data?.errors
      if (errors) {
        const flatErrors = Object.values(errors).flatMap((err: any) =>
          Array.isArray(err) ? err : [err]
        )
        setMessage(flatErrors.map((err: string) => `• ${err}`).join('\n'))
        return
      }
      setMessage(`Ocurrió un error al ${isEdit ? 'editar' : 'agregar'} el aviso.`)
      //
    }
  }

  return (
    <>
      <Modal show={show} onHide={onHide} centered size='lg' backdrop='static' keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>{isEdit ? 'Editar Aviso' : 'Crear Aviso'}</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={{
            titulo: isEdit ? product.titulo : '',
            descripcion: isEdit ? product.descripcion : '',
            contacto: isEdit ? product.contacto : '',
            imagen: isEdit ? 'selected' : '',
            vigente: isEdit ? Boolean(parseInt(product.vigente)) : true,
          }}
          onSubmit={handleAddOrEditProduct}
          validationSchema={validationSchema}
        >
          <Form>
            <Modal.Body>
              <div className='row'>
                <div className='col-12 mb-5'>
                  <InputImage
                    file={file}
                    setFile={setFile}
                    currentImage={isEdit ? product.imagen : ''}
                  />
                  <TextInput name='imagen' hidden />
                </div>
                <div className='col-12 mb-5'>
                  <TextInput name='titulo' placeholder='Escribe el título' label='Título' />
                </div>
                <div className='col-12 mb-5'>
                  <TextArea
                    name='descripcion'
                    placeholder='Escribe la descripción'
                    label='Descripción'
                  />
                </div>
                <div className='col-12 mb-5'>
                  <TextInput
                    name='contacto'
                    placeholder='Escribe el contacto'
                    label='Teléfono/Correo'
                  />
                </div>
                <div className='col-12 mb-5'>
                  <Checkbox name='vigente' label='¿Está vigente?' />
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant='secondary'
                onClick={onHide}
                disabled={loading}
                style={{minWidth: 145}}
              >
                Cerrar
              </Button>
              <Button variant='success' type='submit' style={{minWidth: 145}} disabled={loading}>
                {loading ? (
                  <span className='spinner-border spinner-border-sm text-white'></span>
                ) : isEdit ? (
                  'Guardar Cambios'
                ) : (
                  'Agregar Aviso'
                )}
              </Button>
            </Modal.Footer>
          </Form>
        </Formik>
      </Modal>

      {!!message && (
        <AlertDialog
          message={message}
          show
          success={success}
          onConfirm={() => setMessage('')}
          title={title}
        />
      )}
    </>
  )
}

export default ModalProduct
